import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUsers } from '../actions';
import Helmet from '../components/Helmet';

class UsersListPage extends Component {

    componentDidMount() {
        this.props.fetchUsers();
    }

    renderUsers() {
        return this.props.users.map(user => {
            return  <li key={user.id}>{user.name}</li>;
        });
    }


    head() {
        return <Helmet>
            <title>{`${this.props.users.length} Users Loaded`} </title>
            <meta property="og:title" content="Users App" />
            {/* <meta property="og:type" content="Users App" />
            <meta property="og:image" content="Users App" />
            <meta property="og:url" content="Users App" /> */}
        </Helmet>
    }

    render() {
        return (
            <div>
                {this.head()}
                Here's a big list of users:
                <ul>{this.renderUsers()}</ul>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return { users: state.users };
}

export default {
    loadData: ({dispatch}) => dispatch(fetchUsers()),
    component:  connect(mapStateToProps, { fetchUsers }) (UsersListPage)
}


// WEBPACK FOOTER //
// ./src/client/pages/UsersListPage.js